<!-- <head>
  <meta property="og:title" :content="news.headannounces" />
  <meta property="og:image" :content="news.imagesurl" />
  <meta property="og:url" :content="url_test" />
  <meta property="og:description" :content="news.companyname"/>
</head> -->
<template>
<!--   <div> -->
<!-- http://strd6.com/2011/09/html5-javascript-pasting-image-data-in-chrome/ -->

<div class="container fluid">
  <iframe :src="url" id="iframename" width="500" height="550" @load="redirectUrl('Test');"></iframe>
  <v-btn color="primary" @click="Share_FB()">text</v-btn>

  <vue-headful :title="news.headannounces" :description="news.companyname" :url="url_test" :image="news.imagesurl" />

  <span>{{news.companyname}}</span>
  <img :src="news.imagesurl" alt="" width="100px" height="100px">

  <link-prevue url="https://www.thaijobsgov.com/jobs/307909">
    <template slot-scope="props">
      <div class="card" style="width: 20rem;">
        <img class="card-img-top" :src="props.img" :alt="props.title" />
        <div class="card-block">
          <h4 class="card-title">{{props.title}}</h4>
          <p class="card-text">{{props.description}}</p>
          <a v-bind:href="props.url" class="btn btn-primary">More</a>
        </div>
      </div>
    </template>
  </link-prevue>
</div>
</template>

<script>
// import AddDialog from '@/components/chat/dialog/manage_friend/AddFriendDialog'
import Vue from 'vue'
import {
  sync
} from 'vuex-pathify'
import {
  Decode
} from '@/services'
import LinkPrevue from 'link-prevue'
// import vueHeadful from 'vue-headful'
//
// Vue.component('vue-headful', vueHeadful)
var _ = require('lodash')
// import VueTrix from "vue-trix"

export default {
  props: {
    'dialogGroup': false
  },
  data() {
    return {
      url_test: 'https://testchat.one.th/test2',
      url: process.env.AuthenOneid,
      news: {
        "id": 105,
        "companyname": "กฟผ. การไฟฟ้าฝ่ายผลิต",
        "headannounces": "ข่าวใหม่",
        "imagesurl": "https://services.thaijobjob.com/thai/assets/images/brand_logo/set2.png",
        "opendate": "2020-08-16T22:44:07.238303Z",
        "closedate": "2020-10-16T22:44:07.238303Z",
        "createat": "2020-08-25T06:37:51Z",
        "urlannounces": "https://www.egat.co.th/index.php",
        "nametypejob": "งานรัฐวิสาหกิจ",
        "typenameid": 0,
        "imagecompany": "https://www.jobbkk.com/upload/variety/goverment/20160627_3453.png"
      }
    }
  },
  mounted() {
    // this.createFirst()
  },
  computed: {
    ...sync('*')
  },
  created() {
    console.log(this.url)
    console.log(this.news)
    this.test_plugin()
  },
  components: {
    // VueTrix
    LinkPrevue
  },
  methods: {
    test_plugin () {
      var bot_id = 'Bc020e95179a450548a3c1905d2280f15'
      var div_chatbot = document.createElement('div')
      document.getElementsByTagName('body')[0].appendChild(div_chatbot)
      div_chatbot.outerHTML = "<div id='botChat' style='border-radius: 10px; position: absolute;margin-top: 0px; margin-right: 0px; margin-bottom: 0px; padding: 0px; border: 0px; background: transparent; overflow: hidden; position: fixed; z-index: 16000004; left: 10px; bottom: 10px;display: none; width: 290px; height: 425px; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 3px 2px;'><div id='botTitleBar' style='z-index: 16000005;height: 27px; width: 380px; position:fixed; cursor: pointer; border-top-left-radius: 10px; border-top-right-radius: 10px;'></div><iframe frameborder='0' style='background-color: transparent; vertical-align: text-bottom; position: relative; width: 100%; height: 100%; min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%; margin: 0px; overflow: hidden; display: block;'src='https://chat.one.th/chatplugin/register/chatme/" + bot_id + "'></iframe></div><div id='minBotChat' style='border-radius: 10px;margin-top: 0px; margin-right: 0px; margin-bottom: 0px; padding: 0px; border: 0px; background: transparent;position: fixed; z-index: 16000002; width: 100px; height: 100px; left: 10px; bottom: 15px;'><div id='minBotChatTitle' style='z-index: 16000003;height: 100px; width: 100px; position:fixed; cursor: pointer;'></div><iframe id='iconweb' frameborder='0' style='background-color: transparent; vertical-align: text-bottom; position: relative; width: 100%; height: 100%; min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%; margin: 0px; overflow: hidden; display: block;' src='https://chat.one.th/chatplugin/minchat/chatme/"+ bot_id +"'></iframe></div>"
      document.querySelector('body').addEventListener('click', function (e) {
          e.target.matches = e.target.matches || e.target.msMatchesSelector
          if (e.target.matches('#botTitleBar')) {
            document.getElementById("botChat").style.display = "none"
            document.getElementById("minBotChat").style.display = "block"
          } else if (e.target.matches('#minBotChatTitle')) {
            document.getElementById("botChat").style.display = "block"
            document.getElementById("minBotChat").style.display = "none"
          }
      })
    },
    onClick(prevue) {
      console.log('click', prevue.images, prevue.title, prevue.url, prevue.description)
    },
    Share_FB() {
      let id = 'https://testchat.one.th/test2'
      FB.ui({
        method: 'share',
        href: id
      }, function(response) {
        console.log(response)
      })
      // FB.ui({
      //   method: 'share',
      //   href: id,
      //   action_type: 'og.shares',
      //   action_properties: JSON.stringify({
      //     object: {
      //       'og:url': id,
      //       'og:title': this.news.headannounces,
      //       'og:image:width': 476,
      //       'og:image:height': 476,
      //       'og:image:url': this.news.imagesurl
      //     }
      //   })
      // }, function (response) {
      //   console.log(response)
      // })
    },
    convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          // console.log(linkmsg.slice(0,5))
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
      // console.log(msg.match(urlRegex) !== null);
    },
    changeLan() {
      // window.location.replace("http://www.w3schools.com")
      // this.$i18n.locale = 'en'
      // window.open('/chat/room/R5e174d3e1e8c15002c7b208f3d35a5cb64525ef29e9687d60245b937', '_parent').focus()
    },
    redirectUrl(url) {
      var link = document.getElementById("iframename").contentWindow.location.href
      // console.log(link)
      // console.log(_.includes(link, [process.env.redirect_url]))
      if (_.includes(link, [process.env.redirect_url])) {
        window.open(link, '_parent')
      }
      // window.open(url,'_parent')
    }
    // createFirst () {
    //   console.log('createFirst')
    //   this.iframe = document.getElementById('my_iframe').contentWindow.document;
    //   // this.iframe = document.getElementById("my_iframe").contentDocument.getElementById("iframe_div").innerHTML
    //   var url = 'https://one.th'
    //   var header = {Authorization:'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiIyZGY4Mzk0Ni1iNDM1LTQ1YWYtYmFmMi03OWM0MzEzOGYzNDAiLCJyb2xlIjoic3VwZXJhZG1pbiIsImNvbXBhbnlfaWQiOiI4N2QxOTEyNy0wZTA1LTQ2OWMtOTZiYS1lYjAyYzUxODRhNmMiLCJjcmVhdGVfYXQiOjE1ODIyMTkzODM2OTcsImlhdCI6MTU4MjIxOTM4M30.e1XPh4QJSsaId3hQSog5J8Gna-Vbtg25Eiju3dCsBhU'}
    //   // this.axios.get(url, {headers:header}).then((response) => {
    //   //       iframe.write(response.data);
    //   //   }.catch((error) => {
    //   //       console.log(error);
    //   //   })
    //   this.axios.get(url).then((response) => {
    //     console.log(response.data)
    //     this.iframe.write(response.data)
    //   })
    // }

  }
  // created () {
  //   // // this.token = Decode.decodeToken(localStorage.getItem('tokenuser'))
  //   // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
  //   // // this.sender = localStorage.getItem('email')
  //   // this.getlistfriend()
  // }
}
</script>
<style scoped>
.target {
  border: solid 1px #aaa;
  min-height: 200px;
  width: 30%;
  margin-top: 1em;
  border-radius: 5px;
  cursor: pointer;
  transition: 300ms all;
  position: relative;
}

.contain {
  background-size: cover;
  position: relative;
  z-index: 10;
  top: 0px;
  left: 0px;
}

textarea {
  background-color: white;
}

.active {
  box-shadow: 0px 0px 10px 10px rgba(0, 0, 255, .4);
}

>>>.trix-button-group--file-tools {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/test2.vue